import Utils from '../../common/js/Utils';
import Cookies from "./Cookies";
export default class GuidedSearchPopin {

    static init() {
        Utils.onReady(() => {

            Array.from(document.querySelectorAll('.popin-close-button-js')).forEach(button => {
                button.addEventListener('click', event => {
                    document.querySelectorAll('[data-content-id="guided-search"]').forEach(guidedSearch => guidedSearch.remove());
                    this.disablePopin();
                });
            })

            if (typeof Cookies.getCookie('with_guided_search_popin') === 'undefined' || document.querySelectorAll('.search-tree-branch').length) {
                document.querySelectorAll('[data-content-id="guided-search"]').forEach(guidedSearch => guidedSearch.remove());
            } else {
                document.querySelectorAll('[data-content-id="guided-search"]').forEach(guidedSearch => guidedSearch.classList.remove('hidden'));
            }
        });
    }


    static enablePopin() {
        Cookies.pushCookie('with_guided_search_popin', Math.random());
    }

    static disablePopin() {
        Cookies.deleteCookie('with_guided_search_popin');
    }
}